import styled, { css } from 'styled-components';
import { Button, Crate, Icon, IconButton, Link } from '@perch-labs/shrike';
import { Card } from 'styles';

export const StyledRowCrate = styled.li<StyleProps>`
  padding-top: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
  border-top: ${props =>
    props.hasTopBorder
      ? `1px solid ${props.theme.colors.background.tertiary}`
      : 'none'};
  @media (max-width: ${props => props.theme.breakpoints.tabletPortrait}px) {
    padding-left: ${props => props.paddingLeftMobile || '0px'};
    padding-right: ${props => props.paddingRightMobile || '0px'};
  }
  display: block;

  &:hover {
    background: ${props => props.theme.colors.background.secondary};
    cursor: pointer;
  }
  &:hover .buttonLink {
    background: ${props => props.theme.colors.background.primary};
  }
  .buttonLink:hover {
    background: rgb(0, 0, 0, 0.1);
  }
`;

export const StyledHeader = styled(Crate)<StyleProps>`
  ${props => props.theme.media.xsmall`
  padding: 0px;
  margin: 0px;
  `};

  button > svg {
    transition: transform 0.1s;

    ${props =>
      props.accordionIsOpen
        ? css`
            transform: rotate(180deg);
          `
        : null}
  }
`;

export const StyledButton = styled(Button).attrs({
  fullWidth: true,
  backgroundless: true,
  margin: { top: '16px' },
  color: 'primary',
})``;

export const StyledLink = styled(Link).attrs({
  fullWidth: true,
  backgroundless: true,
  color: 'primary',
})``;

export const StyledIconButton = styled(IconButton)`
  border: 0px;

  &:hover {
    background: ${props => props.theme.colors.background.secondary};
  }
`;

export const StyledIcon = styled(Icon).attrs({
  color: 'errorBright',
  icon: 'ExclamationCircleInverted',
})``;

export const StyledErrorCard = styled(Card)<StyleProps>`
  margin-top: 16px;
  padding: 16px;
  border-left: 8px solid ${props => props.theme.colors.content.error};
  background: ${props => props.theme.colors.background.error};
`;
